module.exports = __webpack_public_path__ + "static/ageas-f04df03302ead19cf9e983303a658c49.svg";